import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useToast } from '../hooks/use-toast';
import { getOrderStatus } from '../lib/api';
import Seo from '../components/Seo';

const STATUS_COPY = {
  pending: {
    title: 'Estamos confirmando tu pago',
    description:
      'Si ya pagaste, en unos minutos recibiras un correo y un mensaje por WhatsApp.'
  },
  paid: {
    title: 'Pago confirmado',
    description: 'Tu pedido esta en proceso de despacho. Te enviaremos la guia pronto.'
  },
  failed: {
    title: 'Pago no confirmado',
    description: 'No pudimos confirmar el pago. Puedes intentarlo de nuevo.'
  }
};

const PagoResultado = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('pending');
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();
  const lastStatusRef = useRef('pending');
  const orderCode =
    searchParams.get('order') || localStorage.getItem('pending_order_code') || '';

  useEffect(() => {
    if (!orderCode) {
      setLoading(false);
      return;
    }

    let isMounted = true;
    let intervalId;

    const fetchStatus = async () => {
      try {
        const data = await getOrderStatus(orderCode);
        if (!isMounted) return;
        const nextStatus = data.status || 'pending';
        if (nextStatus !== lastStatusRef.current) {
          if (nextStatus === 'paid') {
            toast({
              title: 'Pago confirmado',
              description: 'Recibiras un correo y WhatsApp con los detalles.'
            });
          } else if (nextStatus === 'failed') {
            toast({
              title: 'Pago no confirmado',
              description: 'No pudimos confirmar el pago. Intenta de nuevo.',
              variant: 'destructive'
            });
          }
          lastStatusRef.current = nextStatus;
        }
        setStatus(nextStatus);
        if (nextStatus === 'paid') {
          localStorage.removeItem('carrito');
          localStorage.removeItem('pending_order_code');
        }
        if (nextStatus === 'paid' || nextStatus === 'failed') {
          if (intervalId) clearInterval(intervalId);
        }
      } catch {
        if (isMounted) {
          setStatus('pending');
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchStatus();
    intervalId = setInterval(fetchStatus, 5000);

    return () => {
      isMounted = false;
      if (intervalId) clearInterval(intervalId);
    };
  }, [orderCode]);

  const copy = STATUS_COPY[status] || STATUS_COPY.pending;

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <Seo title="Resultado de pago" robots="noindex, nofollow" />
      <div className="container mx-auto px-4 max-w-2xl">
        <Card>
          <CardContent className="p-8 text-center space-y-4">
            <h1 className="text-3xl font-bold">{copy.title}</h1>
            <p className="text-gray-600">{copy.description}</p>
            {orderCode && (
              <p className="text-sm text-gray-500">
                Pedido: <span className="font-semibold">{orderCode}</span>
              </p>
            )}
            {loading && <p className="text-sm text-gray-500">Verificando pago...</p>}
            <div className="pt-4">
              <Link to="/">
                <Button>Volver al inicio</Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PagoResultado;
